module.exports = __webpack_public_path__ + "pic5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic5.jpg
// module id = 1582
// module chunks = 4